import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { TradesDcParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { DateRange } from '@project-types/DateRange';



export const selectGridData = (state: RootState) => state.reportingDeliveriesTradesDc.gridData;
export const selectDateRange = (state: RootState) => state.reportingDeliveriesTradesDc.dateRange;



export const selectValidParams = createSelector(
	[
		selectDateRange,
	],(
		dateRange: DateRange | null,
	) => {
		if (!dateRange) return null;
		let validParams: TradesDcParams = {
			dateFrom: dateRange.from,
			dateTo: dateRange.to,
		};
		return validParams;
	}
);